'use client'
import React from 'react'

import { useGladlyHelpCenter } from '@src/hooks/useGladlyHelpCenter'

import styles from './glady-help-center.module.scss'
import { getIsNativeViewClient } from '@src/quince-site-common/src/helpers/getIsNativeViewClient'

// For gladly help center
// import './gladly-help-center-external.scss' // Moved to _app.tsx

const css = `#gladlyChatTempWrapper,
#gladlyChatDragHandle {
  padding: 1.8rem 2rem !important;
}`

interface Props {}

const GladlyHelpCenter = (props: Props) => {
  useGladlyHelpCenter()
  const quinceMobileApp = getIsNativeViewClient()

  return (
    <>
      {quinceMobileApp && <style>{css}</style>}
      <div id="gladly-help-center" className={styles.gladlyHelpCenter}></div>
    </>
  )
}

export default GladlyHelpCenter
